<template lang="pug">
  #certificate
    section.banner.position-relative
        div.picture
            img.img-fluid.big(src="img/banner/banner_certificate.jpg" alt="banner-certificate")
            img.img-fluid.small(src="img/banner/banner_certificate_mobile.jpg" alt="banner-certificate")
        div.mask_banner
        div.breadcrumb_block
            b-container
                b-breadcrumb(:items="breadcrumb_items")
        div.banner_h1
            h1 Quality &amp; Certification
    b-container.py-sm-3.slogan
        p.text-center.font-weight-bolder.pt-5 Besides endeavoring on developing high-quality products, Nan Ya also makes efforts on quality management, safety management, and certification of products. 
    section
        b-container.container_small
            //- .cert_1.position-relative.clearfix.py-5
            //-     .cert_block.absolute_left.animate_left.text-center
            //-         b-img(src="img/certification/bg_certification_1.jpg" fluid-grow)
            //-     .cert_block.cert_block_box.float_rifht.mt-0.mt-lg-5.animate_right
            //-         div.p-5
            //-             h2.color_first.font-weight-bold.py-3 Certification
            //-             p.py-3 Nan Ya has Awarded ISO 9001:2015 on quality management. Nan Ya not only provides quality consistency, but also to reach the highest standard. On the environment management, Nan Ya has awarded ISO14001:2015, which is the innovative environment regulation to request the company from executing CSR. For the profession safety management, Nan Ya has awarded HSAS18001:2007 and TOSHMS(Taiwan). As a quality company, Nan Ya not only cares about product quality and environment protection, but also put focus on the importance of production safety. 
            //-             b-row.justify-content-center
            //-                 b-col(cols="4")
            //-                     b-img(src="img/certification/certification_ISO9001.jpg" fluid-grow)
            //-                     p.text-certificate ISO 9001
            //-                 b-col(cols="4")
            //-                     b-img(src="img/certification/certification_ISO14001.jpg" fluid-grow)
            //-                     p.text-certificate ISO 14001
            //-                 b-col(cols="4")
            //-                     b-img(src="img/certification/certification_OHSAS18001.jpg" fluid-grow)
            //-                     p.text-certificate OHSAS 18001
            .cert_2.position-relative.clearfix.py-5
                .cert_block.cert_block_box.float_left.mt-0.mt-lg-5.wow.animate_left
                    div.p-5
                        h2.color_first.font-weight-bold.py-3 Food Safety Certification
                        p.py-3 The rigid film is mainly used in packaging which is usually contacted with the product itself. If the film is used to pack stationery or tools, there is no such issue. But if it is for pharmaceutical packaging, it is on the premise of safety. Nan Ya is the only film manufacturer that have passed the FDA certification in Taiwan.
                        b-row
                            b-col(cols="4")
                                b-img(src="img/certification/certification_CDER.jpg" fluid-grow)
                                p.text-certificate FDA
                .cert_block.absolute_right.wow.animate_right.text-center
                    b-img(src="img/certification/bg_certification_2.jpg" fluid-grow)
            //- .cert_3.position-relative.clearfix.py-5
            //-     .cert_block.absolute_left.wow.animate_left.text-center
            //-         b-img(src="img/certification/bg_certification_3.jpg" fluid-grow)
            //-     .cert_block.cert_block_box.float_rifht.mt-0.mt-lg-5.wow.animate_right
            //-         div.p-5
            //-             h2.color_first.font-weight-bold.py-3 National Laboratory
            //-             p.py-3 The inspection of the general supplier will cause deviation because of the equipment or the staff. The factory of Nan Ya in Hsinkang has passed the TAF, which means the inspection of Nan Ya is based on equality, independent, transparent. Nan Ya provides the best quality with guarantee. 
            //-             b-row.justify-content-end
            //-                 b-col(cols="4")
            //-                     b-img(src="img/certification/certification_TAF.jpg" fluid-grow)
            //-                     p.text-certificate TAF
</template>

<script>
export default {
    metaInfo: {
        title: 'Quality & Certification-NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'Besides endeavoring on developing high-quality products, Nan Ya also makes efforts on quality management, safety management, and certification of products.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, Quality & Certification, Quality management, Safety management, Certification of products' },
            { name: 'og:title', content: 'Quality & Certification-NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'Besides endeavoring on developing high-quality products, Nan Ya also makes efforts on quality management, safety management, and certification of products.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
    data() {
        return {
            breadcrumb_items: [
                {
                    text: 'Home',
                    to: { name: 'App' }
                },
                {
                    text: 'Quality & Certification',
                    active: true
                }
            ]
        }
    }
}
</script>

<style lang="sass">
.breadcrumb 
    background-color: transparent

.cert_block
    width: 60%

.float_left
    float: left
    position: relative
    z-index: 3

.float_rifht
    float: right
    position: relative
    z-index: 3

.absolute_left
    position: absolute
    left: 0
.absolute_right
    position: absolute
    right: 0

.cert_block_box
    box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.5)
    background-color: #fafafa
    img
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5)
    p
        color: rgba(0, 0, 0, 0.5)
        line-height: 1.94
        letter-spacing: 0.96px
    p.text-certificate
        font-size: 14px
        color: #000000
        text-align: center

.container_small
    overflow: hidden
@media all and (max-width: 991px) 
    .cert_block
        width: 100%
    .absolute_left, .absolute_right
        position: relative
    .float_left, .float_rifht
        float: none
    .cert_2
        display: flex
        flex-wrap: wrap
        .cert_block
            flex: 0 0 100%
            max-width: 100%
        .cert_block_box
            order: 1
@media all and (max-width: 768px) 
    .container_small
        max-width: 100% !important
        padding-left: 0
        padding-right: 3px
        overflow: hidden
        .cert_block
            img
                width: 90% !important


</style>